import { resolveEndpoint } from '../../resolveEndpoint';
import type { IEndpoint } from '../../types';

import { parsePlayerConfigResponse, parsePlayerConfigResponseXML } from './parsers';
import {
  IPlayerConfigResponse,
  IPlayerConfigResponseXML,
  ParserOptions,
  PlayerConfigType,
  PlayerConfigVersion,
} from './types';

export const playerConfigEndpoint: IEndpoint<PlayerConfigType, ParserOptions> = resolveEndpoint('playerConfig', {
  [PlayerConfigVersion.JSP]: {
    url: '/cgibin/playerconfig.jsp',
    parser: (rawResponse, options): PlayerConfigType =>
      parsePlayerConfigResponseXML(rawResponse as IPlayerConfigResponseXML, options),
    format: 'xml',
    root: 'response',
  },
  [PlayerConfigVersion.PREFERENCES]: {
    url: '/api/config/preferences',
    parser: (rawResponse, options): PlayerConfigType =>
      parsePlayerConfigResponse(rawResponse as IPlayerConfigResponse, options),
    format: 'json',
  },
});
